import { render, staticRenderFns } from "./OilList.vue?vue&type=template&id=716ab440"
import script from "./OilList.vue?vue&type=script&lang=js"
export * from "./OilList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports